import React from 'react';
import PropTypes from 'prop-types';
import ServicesPanel from './ServicesPanel';
import ServicesSection from './ServicesSection';
import ServicesPanelPlaceholder from './ServicesPanelPlaceholder';
import { SFServices } from 'utils/types';

export default class ServicesView extends React.Component {

	get content() {
    const { hasFetched, services, isStudent, isServiceMember, isStaff } = this.props;
    if ( !hasFetched && services.length === 0 ) return <ServicesPanelPlaceholder hideTitle={!isStudent} />;
    return isStudent ? <ServicesPanel services={services}
                                      isStudent={true}
                                      isStaff={isStaff}
                                      isServiceMember={isServiceMember}
                                      canSeeStudentServices={this.props.canSeeStudentServices}
                                      canMakeAppointment={this.props.canMakeAppointment}
                                      hasConnectLicense={this.props.hasConnectLicense}
                                      responsiveKioskEnabled={this.props.responsiveKioskEnabled}
                                      virtualCheckInEnabled={this.props.virtualCheckInEnabled}/>
      : <ServicesSection services={services}
                         isStudent={false}
                         isStaff={isStaff}
                         isServiceMember={isServiceMember}
                         canSeeStudentServices={this.props.canSeeStudentServices}
                         canMakeAppointment={this.props.canMakeAppointment}
                         hasConnectLicense={this.props.hasConnectLicense}
                         responsiveKioskEnabled={this.props.responsiveKioskEnabled}
                         virtualCheckInEnabled={this.props.virtualCheckInEnabled}/>;
	}

	render() {
		return this.content;
	}
}

ServicesView.propTypes = {
  services: SFServices.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  hasFetched: PropTypes.bool.isRequired,
  canSeeStudentServices: PropTypes.bool,
  canMakeAppointment: PropTypes.bool,
  hasConnectLicense: PropTypes.bool,
  responsiveKioskEnabled: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool,
};
